// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Tx++r","loadingWrap":"styles_loadingWrap__GfhQY","noData":"styles_noData__2thZ1","noDataIcon":"styles_noDataIcon__IjRrH"};